import { __assign } from 'tslib';
import { iconButtons } from './icon-buttons.js';

var _a;
var searchClearButton = {
    base: __assign(__assign({}, iconButtons.base), { borderColor: "transparent", color: "var(--button-color-solid)", backgroundColor: "transparent", borderRadius: "100%", fontSize: "inherit", flex: "0 0 var(--button-size)", ":hover:not([data-disabled=true])": {
            backgroundColor: "var(--button-color-light)",
        } }),
    variants: {
        tone: __assign({}, (_a = iconButtons.variants) === null || _a === void 0 ? void 0 : _a.tone),
        size: {
            sm: {
                my: "-18px",
                mr: "-6px",
                "--button-size": "18px",
            },
            md: {
                my: "-18px",
                mr: "-10px",
                "--button-size": "28px",
            },
            lg: {
                my: "-18px",
                mr: "-6px",
                "--button-size": "32px",
            },
        },
    },
    defaultProps: {
        size: "md",
        tone: "primary",
    },
};

export { searchClearButton };
//# sourceMappingURL=search-input.js.map
